import gsap from "gsap";
import ScrollTriggerController from "./scroll-trigger_controller";

export default class SlideInController extends ScrollTriggerController {

    static values = {
        imageInitialScale: { type: Number, default: 1.4 },
        imageScaleStart:   { type: String, default: 'top bottom' },
        imageScaleEnd:     { type: String, default: 'bottom bottom' },
        imageScaleScrub:   { type: Number, default: 0.5 },

        pinStart:          { type: String, default: 'bottom bottom' },
        pinEnd:            { type: String, default: '+=600' },
        pinScrub:          { type: Number, default: 1.5 },

        contentFromX:      { type: Number, default: 100 },
        contentInnerFromY: { type: Number, default: 90 },
        imageToX:          { type: Number, default: -20 },

        contentEase:       { type: String, default: 'power1.out' },
        imageEase:         { type: String, default: 'power1.out' },
        contentInnerEase:  { type: String, default: 'power2.out' },
        contentInnerDelay: { type: String, default: '<0.1' },
    };

    static targets = [
        'content',
        'image',
        'sidebarWrapper',
        'contentInner',
    ];

    connect() {
        this.ctx = gsap.context(() => {
            gsap.set(this.imageTarget, {
                scale: this.imageInitialScaleValue,
            });

            gsap.to(this.imageTarget, {
                scale: 1,
                ease:  'none',
                scrollTrigger: {
                    trigger: this.element,
                    start:   this.imageScaleStartValue,
                    end:     this.imageScaleEndValue,
                    scrub:   this.imageScaleScrubValue,
                },
            });

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: this.element,
                    start:   this.pinStartValue,
                    end:     this.pinEndValue,
                    pin:     this.sidebarWrapperTarget,
                    scrub:   this.pinScrubValue,
                }
            });

            gsap.set(this.contentTarget, {
                xPercent: this.contentFromXValue,
                opacity:  1,
            });

            gsap.set(this.contentInnerTarget, {
                yPercent: this.contentInnerFromYValue,
            });

            tl.to(this.contentTarget, {
                xPercent: 0,
                ease:     this.contentEaseValue,
            }, 0);

            tl.to(this.imageTarget, {
                xPercent: this.imageToXValue,
                ease:     this.imageEaseValue,
            }, 0);

            tl.to(this.contentInnerTarget, {
                yPercent: 0,
                ease:     this.contentInnerEaseValue,
            }, this.contentInnerDelayValue);

        }, this.element);
    }

    disconnect() {
        this.ctx.revert();
        this.ctx = null;
    }
}
